import { Link } from 'react-router-dom';
import logo from "../../assets/img/logo-2.png";
import subscribeBg from "../../assets/img/page/subscribe.jpg";

const FooterFour = () => {
    return (
        <>
            <div className="cta__four">
                <div className="container">
                    <div className="row jc-center">
                        <div className="col-xl-12">
                            <div className="cta__four-area t-center" style={{backgroundImage: `url(${subscribeBg})`}}>
                                <div className="cta__four-area-content">
                                    <h2 className="wow fadeInRight" data-wow-delay=".6s">Join Our Community and Access Exclusive Insights Today</h2>
                                    <div className="wow fadeInDown" data-wow-delay="1.2s">
                                        <Link className="build_button mt-40" to="/contact-us">Free Consultation<i className="flaticon-right-up"></i></Link> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer__four">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="footer__four-area">
                                <div className="row">
                                    <div className="col-lg-4 col-sm-6">
                                        <div className="footer__four-widget mr-40">
                                            <Link className="logo" to="/"><img src={logo} alt="Arclight Developers logo" /></Link>
                                            <h5>We’re Solutions for all civil construction</h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 sm-mt-30">
                                        <div className="footer__four-widget address">
                                            <h4>Contact Info</h4>
                                            <div className="footer__four-widget-address">
                                                <h6><a href="#" target="_blank" rel="noopener noreferrer">Office Address:- 246/B, Purusangit Bunglow, Sector 7A, Gandhingar, Gujarat, 382007</a></h6>
                                                <h4><a href="tel:+919909417333">+91 99094 17333</a></h4>
                                                <h4><a href="tel:+919558554419">+91 95585 54419</a></h4>
                                                <h6 className="mt-10"><a href="mailto:arclightdevelopers@gmail.com" style={{color: '#fff'}}>arclightdevelopers@gmail.com</a></h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 lg-mt-30">
                                        <div className="footer__four-widget ml-40 lg-ml-0">
                                            <h4>Quick links</h4>
                                            <div className="footer-widget-menu">
                                                <ul>
                                                    {/* Updated with real functional links */}
                                                    <li><Link to="/about-us">About Us</Link></li>
                                                    <li><Link to="/services">Services</Link></li>
                                                    <li><Link to="/gallery">Projects</Link></li>
                                                    <li><Link to="/contact-us">Contact Us</Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-sm-6 lg-mt-30">
                                        <div className="footer__four-widget address">
                                            <h4>Support</h4>
                                            <div className="footer-widget-menu">
                                                <ul>
                                                    {/* Dead links for now to prevent crashing */}
                                                    <li><Link to="#" onClick={(e) => e.preventDefault()}>Term & Conditions</Link></li>
                                                    <li><Link to="#" onClick={(e) => e.preventDefault()}>Privacy policy</Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright__area four">
                <div className="container">
                    <div className="row al-center">
                        <div className="col-md-7">
                            <div className="copyright__area-content md-t-center md-mb-10">
                                <p>Copyright 2025 – All Rights Reserved By <Link to="/" target="_blank">Arclight Developers</Link></p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="copyright__area-social t-right md-t-center">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterFour;